import React from 'react'
import { ColumnInstance } from 'react-table'
import { ExtendableStyles } from 'utils-next/types'

import { TableRow } from '@mui/material'

import { TableHeaderCell } from './TableHeaderCell.component'

export type TableHeaderGroupProps<DataType extends object> = ExtendableStyles & {
  headers: ColumnInstance<DataType>[]
}

export function TableHeaderGroup<DataType extends object>({
  headers,
  className,
  style,
}: TableHeaderGroupProps<DataType>) {
  return (
    <TableRow component="tr" className={className} style={style}>
      {headers.map(({ getHeaderProps, ...props }) => (
        <TableHeaderCell {...getHeaderProps()} {...props} key={props.id} />
      ))}
    </TableRow>
  )
}
